import { useContext } from 'react';
import { CurpExtractionContext } from '../context/CurpExtractionContext';

// Hook público para consumir el contexto del banner de extracción CURP.
// Vive en un archivo separado del Provider para que `react-refresh` no
// invalide el HMR del Provider al editar consumidores.
export const useCurpExtraction = () => {
	const ctx = useContext(CurpExtractionContext);
	if (!ctx) {
		throw new Error(
			'useCurpExtraction must be used within <CurpExtractionProvider>',
		);
	}
	return ctx;
};
